import { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import $api from "@/api/index"
import Menus from "./menus"
import styles from "./index.module.less"
import { set_region, set_checked, set_page } from "@/store"

import { useSearchParams, useNavigate, useLocation } from "react-router-dom"
import { classModuleGenerator } from "@/utils"
// https://blog.csdn.net/A20201130/article/details/125754699

function Header({ phone = "400-625-4008" }) {
  const classnames = classModuleGenerator(styles)

  const dispatch = useDispatch()

  const region = useSelector((state) => {
    return state.region
  })

  const [search, setSearch] = useSearchParams()
  const urlRegionId = search.get("regionId")
  let currentSearch = useLocation().search

  const navigate = useNavigate()

  const getRegion = async () => {
    const { result: regionList } = await $api.region.list()
    let curRegion
    for (let key in regionList) {
      curRegion = regionList[key].find((f) => f._id === urlRegionId)
      if (curRegion) break
    }
    if (!curRegion) curRegion = regionList.TOP[0]
    // dispatch({
    //   type: "region/set_region",
    //   payload: { list: regionList, checked: curRegion },
    // })
    dispatch(set_region({ list: regionList, checked: curRegion }))
    // dispatch({
    //   type: "SET_REGION",
    //   region: {
    //     list: regionList,
    //     checked: curRegion,
    //   },
    // })
  }

  const getData = async () => {
    const { result: pageData } = await $api.region.detail(region.checked._id)
    dispatch(set_page(pageData))
    // dispatch({
    //   type: "page/set_page",
    //   payload: pageData,
    // })
  }

  useEffect(() => {
    if (!Object.keys(region.list).length) {
      getRegion()
    }
  }, [])
  useEffect(() => {
    if (region.checked._id) getData()
  }, [region.checked._id])

  function changeRegion(model) {
    if (model._id !== region.checked._id) {
      dispatch(set_checked({ checked: model }))
    }
    document.querySelector(`.${styles.cityList}`).style.display = "none"
    setTimeout(() => {
      document.querySelector(`.${styles.cityList}`).style.display = ""
    }, 100)

    if (urlRegionId) {
      currentSearch = currentSearch.replace(urlRegionId, model._id)
    } else {
      currentSearch =
        currentSearch + (model._id === "0" ? "" : `&regionId=${model._id}`)
    }
    setSearch(currentSearch)

    //页面刷新，营造切换分站的效果
    setTimeout(() => {
      window.location.reload()
    }, 0)
  }
  return (
    <>
      <header>
        <div className={classnames("topnav")}>
          <div className={classnames("inner")}>
            学大教育全日制网站
            <div className={classnames("city-wrapper")}>
              <div className={classnames("citys")}>
                校区切换：
                {Object.keys(region.list).length > 0 && (
                  <span>{region.checked.name}</span>
                )}
                <div className={styles.cityList}>
                  {Object.keys(region.list).map((group) => (
                    <dl key={group}>
                      <dt>{group}</dt>
                      {region.list[group] &&
                        region.list[group].map((city) => (
                          <dd
                            key={city._id}
                            onClick={() => {
                              changeRegion(city)
                            }}
                          >
                            <span>{city.name}</span>
                          </dd>
                        ))}
                    </dl>
                  ))}
                </div>
              </div>
            </div>
            <a className={styles.phone} href={"tel: " + phone}>
              全国24小时服务热线:{phone}
            </a>
          </div>
        </div>
        <div className={classnames("wrapper")}>
          <div className={classnames("inner")}>
            <div
              className={styles.logo}
              onClick={() => {
                navigate(
                  `/${
                    region.checked._id ? "?regionId=" + region.checked._id : ""
                  }`
                )
              }}
            >
              <img src={require("@/assets/images/logo.png")} alt="logo" />
            </div>
            <div className={styles.menus}>
              <Menus />
            </div>
          </div>
        </div>
      </header>
    </>
  )
}

// const mapStateToProps = (state) => {
//   // console.log(state, ownProps)
//   console.log(state)
//   return {
//     // regionList:[]
//     regionId: state.region.checked._id,
//     regionName: state.region.checked.name,
//     regionList: state.region.list,
//     // banners: [{…}]
//     // classs: (3) [{…}, {…}, {…}]
//     // photos: (3) [{…}, {…}, {…}]
//     // teachers: [{…}]
//   }
// }

// const mapDispatchToProps = (dispatch) => {
//   return {
//     setRegion: (region, regionList, pageData) => {
//       console.log("dispatch1", region, regionList, pageData)
//       dispatch({ type: "SET_REGIONLIST", regionList })
//       console.log("dispatch2", region, regionList, pageData)
//       dispatch({ type: "SET_REGION", region })

//     },
//     // setRegionList: (regionList) => {
//     //   dispatch({ type: "SET_REGIONLIST", regionList })
//     // },
//   }
// }

export default Header
